/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeStudioCurrentModel } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-options-axis',
  templateUrl: './theme-options-axis.component.html',
  styleUrls: ['./theme-options-axis.component.css']
})
export class ThemeOptionsAxisComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() current: ThemeStudioCurrentModel;
  @Input() axesXY: 'x' | 'y';
  
  color = ItemColor('themes');

  editorIndex: number;
  editorIndexMax: number;

  constructor() {
    this.editorIndex = 0;
    this.editorIndexMax = 3;
  }

  receiveNext(isNext: boolean) {
    this.editorIndex = this.editorIndex + (isNext ? 1 : -1);
    if(this.editorIndex < 0) this.editorIndex = this.editorIndexMax;
    if(this.editorIndex > this.editorIndexMax) this.editorIndex = 0;
  } 

}
